import React from 'react';
import ReactDOM from 'react-dom';
import FacetList from './components/FacetList';

const facetListContainer = document.querySelector('[data-react=facetListContainer]');

if (facetListContainer && window.facetListData) {
  ReactDOM.render(<FacetList facetListData={window.facetListData} />, facetListContainer);
}
